import PropTypes from 'prop-types';
// @mui
import { Typography, Stack } from '@mui/material';
// components

import Image from '../../components/image';
//
import { StyledRoot, StyledSectionBg, StyledSection, StyledContentS } from './styles';

// ----------------------------------------------------------------------

LoginLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  illustration: PropTypes.string,
};

export default function LoginLayout({ children, illustration, title }) {
  return (
    <StyledRoot>
      <StyledSection>
        <Typography
          variant="h3"
          sx={{ mb: 10, maxWidth: 440, textAlign: 'center', color: 'common.white' }}
        >
          {title || 'Hi, Welcome back'}
        </Typography>

        <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          src={illustration || '/assets/illustrations/illustration_dashboard.png'}
          sx={{ maxWidth: 720 }}
        />

        <StyledSectionBg />
      </StyledSection>

      <StyledContentS>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContentS>
    </StyledRoot>
  );
}
